import { useState, useEffect } from "react";

export default function usePagination(data, rowsPerPage) {
    const [page, setPage] = useState(0);

    const totalPages = Math.ceil(data.length / rowsPerPage);

    const paginatedData = data.slice(
        page * rowsPerPage,
        (page + 1) * rowsPerPage
    );

    // 🔥 FIXED
    useEffect(() => {
        setPage(0);
    }, [rowsPerPage]);

    return {
        page,
        setPage,
        totalPages,
        paginatedData
    };
}